import { React, useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { LocationLib } from "@cisco/spaces-dash-lib-lh2";
import { I18nContext } from "./contexts/i18nContext";
import App from "./components/app/app";
import LoadingProvider from "./providers/LoadingProvider";
import NotificationProvider from "./providers/NotificationProvider";
import { PropertiesContext } from "./contexts/propertiesContext";
import { getHomeProperties } from "./service/business-hierarchy-service";

export default function BusinessHierarchy(props) {
  const {
    appData: { i18n }
  } = props;
  const [properties, setProperties] = useState(null);

  const getGoogleApiKey = async () => {
    const homePropertiesRes = await getHomeProperties();
    if (homePropertiesRes.status) {
      const { data } = homePropertiesRes;
      setProperties(data);
    }
  };

  useEffect(() => {
    getGoogleApiKey();
  }, []);

  return (
    <I18nContext.Provider value={i18n}>
      <BrowserRouter>
        <NotificationProvider>
          <LoadingProvider>
            <LocationLib />
            <PropertiesContext.Provider value={properties}>
              <App i18n={i18n} />
            </PropertiesContext.Provider>
          </LoadingProvider>
        </NotificationProvider>
      </BrowserRouter>
    </I18nContext.Provider>
  );
}
